/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="login.model.ts" />

module Eseebase {
    export class AuthInterceptor {
        public inFlightAuthRequest: ng.IHttpPromise<any>;
        public isOciMode: boolean;
        constructor(public $injector: ng.auto.IInjectorService, public $q: ng.IQService, private cookiesService: CookiesService) {
            this.inFlightAuthRequest = null;
            this.isOciMode = false;
        }

        public responseError = (rejection: any) => {
            if (rejection.status === 401) {
                var deferred = this.$q.defer();
                if (this.inFlightAuthRequest == null) {
                    var refreshToken = this.cookiesService.readCookie('refreshToken');
                    if (refreshToken == null) {
                        if (this.isOciMode) {
                            if (window.location.hash != 'oci/#!/unauthorized') {
                                window.location.href = '/oci/#!/unauthorized';
                            }
                        }
                        else {
                            if (window.location.hash != '#!/login') {
                                window.location.href = '/#!/login?redirectUrl=' + encodeURIComponent(window.location.pathname);
                            }
                        }
                        return this.$q.reject(rejection);
                    }
                    this.inFlightAuthRequest = this.postAsForm('token', { refresh_token: refreshToken, grant_type: 'refresh_token', client_id: 'ngAuthApp' });
                }
                var vm = this;
                this.inFlightAuthRequest.then(function (r) {
                    vm.inFlightAuthRequest = null;
                    if (r.data.access_token && r.data.refresh_token) {
                        var login = new LoginModel();
                        login.accessToken = r.data.access_token;
                        login.refreshToken = r.data.refresh_token;
                        vm.saveAccessToken(login.accessToken);
                        vm.saveRefreshToken(login.refreshToken);
                        //window.location.reload();
                        var httpService = vm.$injector.get("$http");
                        var sceService = vm.$injector.get("$sce");
                        var cfg = rejection.config;
                        cfg.url = sceService.getTrustedUrl(rejection.config.url);
                        httpService(cfg).then(function (resp) {
                            deferred.resolve(resp);
                        }, function (resp) {
                            deferred.reject();
                        });
                    } else {
                        deferred.reject();
                    }
                }, function (response) {
                    vm.inFlightAuthRequest = null;
                    deferred.reject();
                    if (this.isOciMode) {
                        if (window.location.hash != 'oci/#!/unauthorized') {
                            window.location.href = '/oci/#!/unauthorized';
                        }
                    }
                    else {
                        if (window.location.hash != '#!/login') {
                            window.location.href = '/#!/login?redirectUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    }
                    return;
                });
                return deferred.promise;
            }
            return this.$q.reject(rejection);
        };

        public request = (config: any) => {
            var accessToken = this.cookiesService.readCookie('accessToken');
            var language = this.cookiesService.readCookie('currentLanguage');
            if (accessToken) {
                config.headers['Authorization'] = 'Bearer ' + accessToken;
            }
            if (language) {
                config.headers['Accept-Language'] = language;
            }
            else {
                config.headers['Accept-Language'] = 'en-GB';
            }
            config.url.indexOf = function () { };
            config.headers['TimezoneOffsetMinutes'] = new Date().getTimezoneOffset();
            return config;
        };

        public requestError = (rejection: any) => {
            return this.$q.reject(rejection);
        };

        private postAsForm(url: string, data: any) {
            return this.$injector.get("$http")({
                method: 'POST',
                url: `/${url}`,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: data
            });
        }

        private saveAccessToken(accessToken: string) {
            this.cookiesService.createCookie('accessToken', accessToken, 0);
        }

        private saveRefreshToken(refreshToken: string) {
            this.cookiesService.createCookie('refreshToken', refreshToken, 144000);
        }
    }

    AuthInterceptor.$inject = ['$injector', '$q', 'CookiesService'];

    angular
        .module('eseebase')
        .service('AuthInterceptor', AuthInterceptor)
        .config(['$httpProvider', (_$httpProvider: ng.IHttpProvider) => {
            _$httpProvider.interceptors.push('AuthInterceptor');
        }]);
}